import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Divider,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import PropTypes from 'prop-types';
import FormList from './FormList';
import { useMotivesStyles } from '../styles';
import useExecuteScroll from '../../../../../hooks/useExecuteScroll/useExecuteScroll';

const Motives = ({ ...props }) => {
  const { motives } = props;
  const classes = useMotivesStyles();
  const { ticketNoProductStatus } = useSelector(
    (innerState) => innerState.ticketReducer,
  );

  useEffect(() => {
    if (ticketNoProductStatus === 'succeded') setExpanded(false);
  }, [ticketNoProductStatus]);

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    if (isExpanded) executeScroll();
    setExpanded(isExpanded ? panel : false);
  };

  const accordionRef = useRef(null);
  const executeScroll = () => useExecuteScroll(accordionRef);

  return (
    <Box width="100%">
      {motives.map((motive, index) => (
        <>
          <Accordion
            elevation={0}
            className={classes.accordion}
            onChange={handleChange(index)}
            expanded={expanded === index}
          >
            <AccordionSummary
              ref={accordionRef}
              data-cy={motive.dataCy}
              expandIcon={expanded === index ? <RemoveIcon /> : <AddIcon />}
            >
              <Typography className={classes.title}>{motive.title}</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.container}>
              <FormList type={motive.type} motiveId={motive.id} />
            </AccordionDetails>
          </Accordion>
          <Divider />
        </>
      ))}
    </Box>
  );
};

Motives.propTypes = {
  motives: PropTypes.array,
};

export default Motives;
